import React, { useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from "reactstrap";
import MantisBusinessDetail from "../MantisBusinessDetail";
import BusinessConfigTab from "./BusinessConfigTab";
import ApiKeysTab from "./ApiKeysTab";
import BusinessUsersTab from "./BusinessUsersTab";
import DocumentFormatsTab from "./DocumentFormatsTab";
import BusinessPermissionsTab from "./BusinessPermissionsTab";
import BusinessSectionsTab from "./BusinessSectionsTab";
import BusinessDashboardsTab from "./BusinessDashboardsTab";
import PageHeader from "./PageHeader";
import "./styles/businessDetailWithTabs.scss";

const select = (state) => {
  return {
    userId: state.auth.userId,
    token: state.auth.token,
    user: state.auth.user,
    mantisBusiness: state.auth.mantisBusiness,
  };
};

function MantisBusinessDetailWithTabs(props) {
  const [activeTab, setActiveTab] = useState("info");
  const { id } = useParams();

  const tabs = [
    { id: "info", label: "Información", icon: "fas fa-info-circle" },
    { id: "permissions", label: "Permisos", icon: "fas fa-lock" },
    { id: "sections", label: "Secciones", icon: "fas fa-puzzle-piece" },
    { id: "dashboards", label: "Dashboards", icon: "fas fa-chart-line" },
    { id: "config", label: "Configuración", icon: "fas fa-cog" },
    { id: "apikeys", label: "API Keys", icon: "fas fa-key" },
    { id: "users", label: "Users", icon: "fas fa-users" },
    { id: "formats", label: "Doc Formats", icon: "fas fa-file-alt" },
  ];

  return (
    <div className="business-detail-with-tabs">
      <PageHeader
        title="Detalles de la empresa"
        subtitle="Información, permisos, usuarios y configuración del negocio"
      />

      {/* Tab Navigation */}
      <Row className="tab-nav-row">
        <Col xs={12}>
          <Nav tabs className="business-detail-nav-tabs">
            {tabs.map((tab) => (
              <NavItem key={tab.id}>
                <NavLink
                  active={activeTab === tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className="nav-link-item"
                >
                  <i className={tab.icon} />
                  <span>{tab.label}</span>
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Col>
      </Row>

      {/* Tab Content */}
      <TabContent activeTab={activeTab}>
        {/* Existing Info Tabs */}
        <TabPane tabId="info">
          <MantisBusinessDetail {...props} />
        </TabPane>

        <TabPane tabId="permissions">
          <div className="tab-content-wrapper">
            <BusinessPermissionsTab {...props} />
          </div>
        </TabPane>

        <TabPane tabId="sections">
          <div className="tab-content-wrapper">
            <BusinessSectionsTab {...props} />
          </div>
        </TabPane>

        <TabPane tabId="dashboards">
          <div className="tab-content-wrapper">
            <BusinessDashboardsTab {...props} />
          </div>
        </TabPane>

        {/* New Tabs */}
        <TabPane tabId="config">
          <div className="tab-content-wrapper">
            <BusinessConfigTab
              mantisBusinessId={id}
              token={props.token}
            />
          </div>
        </TabPane>

        <TabPane tabId="apikeys">
          <div className="tab-content-wrapper">
            <ApiKeysTab
              mantisBusinessId={id}
              token={props.token}
            />
          </div>
        </TabPane>

        <TabPane tabId="users">
          <div className="tab-content-wrapper">
            <BusinessUsersTab
              mantisBusinessId={id}
              token={props.token}
              requesterId={props.userId}
            />
          </div>
        </TabPane>

        <TabPane tabId="formats">
          <div className="tab-content-wrapper">
            <DocumentFormatsTab
              mantisBusinessId={id}
              token={props.token}
              mantisBusinessUserId={props.userId}
            />
          </div>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default connect(select)(MantisBusinessDetailWithTabs);
